import React from 'react'

const ScheduleDeviation = () => {
    return (
        <>ScheduleDeviation mobile</>
    )
}

export { ScheduleDeviation }